export interface SubmitData {
  vorname: string;
  nachname: string;
  email: string;
  telefon: string;
  'g-recaptcha-response'?: string;
  produkte: Array<{
    kategorie: 'fenster' | 'tueren' | 'lichtschacht';
    name: string;
    typ?: string;  // z.B. "Rollo", "Drehfenster", etc.
    breite: number;
    hoehe: number;
    anzahl: number;
  }>;
}

type TrackingMetadata = Record<string, string | number | boolean | string[] | number[] | null | undefined>;

declare global {
  interface Window {
    ISK_API_BASE?: string;
  }
}

// Basis-URL für die WordPress REST API.
// Wird vom Embed-Script gesetzt, wenn der Konfigurator auf einer externen Seite läuft.
// Ohne gesetzte Variable bleiben die Aufrufe relativ (WordPress-intern).
const getApiBase = (): string => {
  if (typeof window !== 'undefined' && window.ISK_API_BASE) {
    return window.ISK_API_BASE.replace(/\/+$/, '');
  }
  return '';
};

const apiUrl = (path: string): string => `${getApiBase()}${path}`;

const getTrackingSessionId = (): string => {
  const storageKey = 'isk_tracking_session_id';

  try {
    const existingSessionId = window.sessionStorage.getItem(storageKey);
    if (existingSessionId) {
      return existingSessionId;
    }

    const sessionId = `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    window.sessionStorage.setItem(storageKey, sessionId);
    return sessionId;
  } catch (error) {
    return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  }
};

export const trackKonfiguratorEvent = async (
  eventName: string,
  step?: number,
  metadata: TrackingMetadata = {}
): Promise<void> => {
  try {
    await fetch(apiUrl('/wp-json/isk/v1/track-event'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        event_name: eventName,
        session_id: getTrackingSessionId(),
        step,
        page_url: window.location.href,
        referrer: document.referrer,
        metadata
      }),
      keepalive: true
    });
  } catch (error) {
    console.error('Tracking-Event konnte nicht gesendet werden:', error);
  }
};

export const submitKonfigurator = async (data: SubmitData): Promise<{ success: boolean; redirectUrl?: string }> => {
  try {
    console.log('Sende Daten:', data);

    // Erstelle ein JSON-Objekt für den Request
    const requestData = {
      vorname: data.vorname,
      nachname: data.nachname,
      email: data.email,
      telefon: data.telefon,
      'g-recaptcha-response': data['g-recaptcha-response'],
      produkte: data.produkte
    };

    console.log('Request Daten:', requestData);

    const response = await fetch(apiUrl('/wp-json/isk/v1/submit'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(requestData)
    });

    // Hole den rohen Response-Text für besseres Debugging
    const responseText = await response.text();
    console.log('Rohe Server-Antwort:', responseText);

    if (!response.ok) {
      let errorMessage = `HTTP Fehler ${response.status}`;
      try {
        const errorData = JSON.parse(responseText);
        errorMessage = errorData.message || errorMessage;
        console.error('Server-Fehler Details:', errorData);
      } catch (e) {
        console.error('Konnte Fehler-Response nicht parsen:', e);
        console.error('Rohe Fehler-Antwort:', responseText);
    }
      throw new Error(errorMessage);
    }

    try {
      const result = JSON.parse(responseText);
      console.log('Geparste Server-Antwort:', result);

    return {
      success: true,
      redirectUrl: result.redirect_url
    };
    } catch (e) {
      console.error('Fehler beim Parsen der Erfolgsantwort:', e);
      throw new Error('Ungültiges Antwortformat vom Server');
    }
  } catch (error) {
    console.error('Fehler beim Senden der Daten:', error);
    throw error;
  }
}; 
